import { render } from "./CrImprint.vue?vue&type=template&id=ebb9f9dc&scoped=true"
import script from "./CrImprint.vue?vue&type=script&lang=js"
export * from "./CrImprint.vue?vue&type=script&lang=js"

import "./CrImprint.vue?vue&type=style&index=0&id=ebb9f9dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb9f9dc"]])

export default __exports__